import { render, staticRenderFns } from "./vrindex.vue?vue&type=template&id=26173eb3&"
import script from "./vrindex.vue?vue&type=script&lang=js&"
export * from "./vrindex.vue?vue&type=script&lang=js&"
import style0 from "./vrindex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports